import styled from 'styled-components'



export const Form = styled.form`
  display:grid;
  grid-template-columns:0.25fr 1.1fr 0.5fr 0.5fr 0.5fr 0.75fr;
  column-gap:10px;


`
export const ItemGrid = styled.div`

grid-column-start:  ${(props) => props.start};
`
